module.exports = __webpack_public_path__ + "static/LilyLi-4b09d858d1101819d634339575fc3174.jpg";